import React from "react";
import Helmet from "react-helmet";
import { StaticQuery, graphql } from "gatsby";
import "tachyons";

export default (props) => (
  <StaticQuery
    query={graphql`
      query {
        site {
          siteMetadata {
            title
            subTitle
          }
        }
      }
    `}
    render={(data) => (
      <Helmet>
        <title>
          {props.title + " - " + data.site.siteMetadata.subTitle}
        </title>

        <meta
          name="description"
          content={props.title + " - " + data.site.siteMetadata.subTitle}
        ></meta>
      </Helmet>
    )}
  />
);
